//////////////////////////////////////////////////////////////////////
//
//  10/12/18
//  src/containers/GrillData.js
//
//  This file will contain all the 'canned' Bar and Grill Data.
//

//
//  This is the raw Bar and Grill data.
//
const GrillData = [
 {
   miles : "2.1  mi.",
   name  : "Hob Nob Sports Grill",
   music : false,
   food  : true,
   happy : true,
   notes : true,
   board : true,
   line1 : "Hob Nob Sports Grill",
   line2 : "Arizona's Home",
   line3 : "for",
   line4 : "CHICAGO SPORTS",
   mpop  : "",
   fpop  : "Chicago Style Hot Dogs",
   hpop  : "Happy Hour Daily 3-6 PM",
   addr  : "http://www.hobnobsports.com/",
 },
 {
   miles : "4.4  mi.",
   name  : "Cactus Jack's Bar and Grill",
   music : true,
   food  : true,
   happy : true,
   notes : true,
   board : true,
   line1 : " ->>- Cactus Jack's -<<-",
   line2 : "Jerry Garcia Tribute Band",
   line3 : "Friday 8:30 pm / $8",
   line4 : "Come Early for best Seating",
   mpop  : "Music Every Fri and Sat: 9 - 12 AM",
   fpop  : "Burgers and Sandwhiches",
   hpop  : "Happy Hour Sun-Thur 3-6 PM",
   addr  : "http://www.cactusjacksbar.co/",
 },
 {
   miles : "5.2  mi.",
   name  : "Baseline Sports Pub",
   music : false,
   food  : false,
   happy : true,
   notes : false,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "",
   fpop  : "",
   hpop  : "Happy Hour Mon-Fri 3-7 PM",
   addr  : "",
 },
 {
   miles : "6.1  mi.",
   name  : "Copper Still Moonshine Grill",
   music : false,
   food  : false,
   happy : false,
   notes : true,
   board : true,
   line1 : "New Location",
   line2 : "Opens Tuesday, Nov 28th",
   line3 : "7450 W. Chandler Blvd.",
   line4 : "Just East of I-10",
   mpop  : "",
   fpop  : "",
   hpop  : "",
   addr  : "https://copperstillmoonshinegrill.com/",
 },
 {
   miles : "6.7  mi.",
   name  : "The Irish Hare Pub",
   music : false,
   food  : true,
   happy : true,
   notes : true,
   board : true,
   line1 : "Great Irish Pub",
   line2 : "Traditional Irish Food",
   line3 : "New to the Neighborhood",
   line4 : "See you there!",
   mpop  : "",
   fpop  : "Great Corned Beef Hash",
   hpop  : "Happy Hour Daily 3-6 PM",
   addr  : "https://theirishhare.com/",
 },
 {
   miles : "7.0  mi.",
   name  : "Goldwater Brewing Co.",
   music : false,
   food  : false,
   happy : true,
   notes : false,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "",
   fpop  : "",
   hpop  : "Happy Hour Daily",
   addr  : "",
 },
 {
   miles : "8.9  mi.",
   name  : "Two Brothers Tap House",
   music : false,
   food  : true,
   happy : true,
   notes : true,
   board : true,
   line1 : "Two Brothers Tap House",
   line2 : "Artisan Brewing",
   line3 : "Follow Your Passion",
   line4 : "Drink Ours",
   mpop  : "",
   fpop  : "The perfect spot to grab a brew and eat.",
   hpop  : "Happy Hour Daily 3-6 PM",
   addr  : "http://twobrothersbrewing.com/",
 },
 {
   miles : "12.4  mi.",
   name  : "Thirsty Lion Pub and Grill",
   music : false,
   food  : true,
   happy : true,
   notes : true,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "",
   fpop  : "Try our Scottish Eggs",
   hpop  : "Happy Hour M-F 3-6 PM",
   addr  : "https://www.thirstyliongastropub.com/arizona",
 },
 {
   miles : "15.5  mi.",
   name  : "Philly's Sport Grill",
   music : false,
   food  : true,
   happy : true,
   notes : true,
   board : true,
   line1 : "Philly's Sports Grill",
   line2 : "Sat. Night: UFC 7-9",
   line3 : "Drink Specials",
   line4 : "all fight night",
   mpop  : "",
   fpop  : "Special Today: Philly Cheesesteaks",
   hpop  : "Try Our Beer of the Month: Summer Shandy",
   addr  : "http://www.phillyssportsgrill.com/",
 },
 {
   miles : "16.0  mi.",
   name  : "Lucky's",
   music : false,
   food  : true,
   happy : true,
   notes : true,
   board : true,
   line1 : "Lucky's",
   line2 : "inside Lone Butte Casino",
   line3 : "Brand-new bar",
   line4 : "Open Daily 10am - 2am",
   mpop  : "",
   fpop  : "Multiple Food Locations",
   hpop  : "Daily Drink Specials",
   addr  : "https://www.wingilariver.com/index.php/lone-butte-casino/lounges-bars/luckys",
 },
];

export default GrillData;



// WEBPACK FOOTER //
// ./src/components/GrillData.js